import type { FormSchema } from '@concours/shared'

export interface FormSummary {
  id: string
  code: string
  title: string
  description: string | null
  latestVersion: number | null
  hasDraft: boolean
  competitions: number
  updatedAt: string | null
}

export interface VersionSummary {
  id: string
  formId: string
  version: number | null
  status: 'draft' | 'published' | 'archived'
  sections: number
  fields: number
  basedOn: string | null
  publishedAt: string | null
  publishedBy: string | null
  publishReason: string | null
  createdAt: string | null
  updatedAt: string | null
}

export interface VersionWithSchema extends VersionSummary {
  schema: FormSchema
}

export interface FormDetail {
  id: string
  code: string
  title: string
  description: string | null
  versions: VersionSummary[]
  usage: {
    competitionId: string
    reference: string
    title: string
    status: string
    version: number
  }[]
}

export const FORMS_KEY = ['admin', 'forms'] as const
